import React from 'react';
import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

interface SessionMergeToolbar {
  hint: string;
  compareLabel: string;
  canCompare: boolean;
  onCompare: () => void;
}

// Set apart from the list so merge mode reads as a mode the page is in, not a filter.
const containerStyle: React.CSSProperties = {
  marginBottom: '16px',
  padding: '12px 16px',
  border: '1px solid #3b82f6',
  borderRadius: '8px',
  backgroundColor: '#dbeafe',
};

/** Shown in merge mode: what to do, and the Compare action once two sessions are picked. */
const SessionMergeToolbarComponent: React.FC<SessionMergeToolbar> = ({
  hint,
  compareLabel,
  canCompare,
  onCompare,
}) => (
  <div style={containerStyle}>
    <Row alignmentHorizontal="justify" alignmentVertical="center">
      <Text type="b200">{hint}</Text>
      <Button onClick={onCompare} disabled={!canCompare}>
        {compareLabel}
      </Button>
    </Row>
  </div>
);

export default SessionMergeToolbarComponent;
